<template>
    <md-list>
        <div class="radios">
            <label for="predictive">Select Historical or Climate Projection Workflow</label>
            <md-radio v-model="predictive" :value="false" @change="updatePredictive($event)">Historical</md-radio>
            <md-radio v-model="predictive" :value="true" @change="updatePredictive($event)">Climate Projection</md-radio>
        </div>
        <md-list-item>
            <md-field>
                <label for="zone">Select Zone</label>
                <md-select v-model="config.zone" name="zone" id="zone" @input="updateZone($event)">
                    <md-option value="hoa">Horn of Africa</md-option>
                </md-select>
            </md-field>
        </md-list-item>
        <md-list-item>
            <md-field>
                <label for="country">Select Country</label>
                <md-select v-model="config.country" name="country" id="country" @input="updateCountry($event)">
                    <div v-for="country in countries" :key="country.code">
                        <md-option :value="country.code">{{ country.name }}</md-option>
                    </div>
                </md-select>
            </md-field>
        </md-list-item>
        <md-list-item>
            <md-field v-if="predictive">
                <label for="period">Select Time Period</label> 
                <md-select v-model="config.year" name="year" id="year">
                    <md-option value="2030">2030</md-option>
                    <md-option value="2050">2050</md-option>
                    <md-option value="2080">2080</md-option>
                </md-select>
            </md-field>
            <md-field v-else>
                <label for="period">Select Time Period</label>
                <md-select v-model="config.period" name="period" id="period" @input="updatePeriod($event)">
                    <md-option value=90>Last Three Months</md-option>
                    <md-option value=365>Last Year</md-option>
                </md-select>
            </md-field>
        </md-list-item>
        <md-list-item v-if="predictive">
            <md-field>
                <label for="scenario">Select scenario</label>
                <md-select v-model="config.scenario" name="scenario" id="scenario" @input="updateScenario($event)">
                    <md-option value="rcp45">RCP4.5</md-option>
                    <md-option value="rcp85">RCP8.5</md-option>
                </md-select>
            </md-field>
        </md-list-item>
        <md-list-item> 
            <!-- <md-field v-if="predictive">
                <label for="workflow">Select Workflow</label>
                <md-select v-model="config.workflow" name="workflow" id="workflow" @input="updateWorkflow($event)">
                    <md-option value="FUTURE">Future climate security</md-option>
                </md-select>
            </md-field>
            <md-field v-else>
                <label for="workflow">Select Workflow</label>
                <md-select v-model="config.workflow" name="workflow" id="workflow" @input="updateWorkflow($event)">
                    <md-option v-for="workflow in workflows" :value="workflow[0]" :key="workflow[0]">{{workflow[1]}}</md-option>
                </md-select>
            </md-field> -->
            <md-field>
                <label for="workflow">Select Workflow</label>
                <md-select v-model="config.workflow" name="workflow" id="workflow" @input="updateWorkflow($event)">
                    <md-option v-for="workflow in workflows" :value="workflow[0]" :key="workflow[0]">{{workflow[1]}}</md-option>
                </md-select>
            </md-field>
        </md-list-item>
        <md-button v-if="!loading" class="md-raised md-primary" @click="runVisualization()">Refresh</md-button>
        <md-button v-else class="md-raised md-primary">
            Loading...
        </md-button>
    </md-list>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "OAConfigurationPanel",
    data() {
        return {
            predictive: false, //state 
            zones: {
                "hoa": [
                    {name: "All countries", code: "HOA"},
                    {name: "Djibouti", code: "DJI"},
                    {name: "Eritrea", code: "ERI"},
                    {name: "Ethiopia", code: "ETH"},
                    {name: "Kenya", code: "KEN"},
                    {name: "Somalia", code: "SOM"},
                    {name: "South Sudan", code: "SSD"},
                    {name: "Sudan", code: "SDN"},
                    {name: "Uganda", code: "UGA"}
                ]
            },
            defaultWorkflows: [["DROUGHT", "Drought"], ["CLIMATE", "Climate security simple"], ["ENV", "Environmental security extensive"]],
            predictiveWorkflows: [["FUTURE", "Future climate security"]], 
            workflows: []
        }
    },
    created() {
        if (this.predictive) {
            this.workflows = this.predictiveWorkflows
        } else {
            this.workflows = this.defaultWorkflows
        }
        this.$store.commit('dashboard/setWorkflow', this.workflows[0][0]);
    },
    computed: {
        ...mapState({
            config: state => state.dashboard.config
        }),
        loading() {
            return this.$store.getters['dashboard/isLoading'];
        },
        countries(){
            return this.zones[this.config.zone];
        }
    },
    methods: { //actions
        updateZone(zone){
            this.$store.commit('dashboard/setZone', zone); //change state using commit 
        },
        updateCountry(country){
            this.$store.commit('dashboard/setCountry', country);
        },
        updatePeriod(period){
            this.$store.commit('dashboard/setPeriod', period);
        },
        updateWorkflow(workflow){
            this.$store.commit('dashboard/setWorkflow', workflow);
        },
        updatePredictive(predictive){
            if (this.predictive) {
                this.workflows = this.predictiveWorkflows
            } else {
                this.workflows = this.defaultWorkflows
            }
            this.$store.commit('dashboard/setPredictive', predictive)
            this.$store.commit('dashboard/setWorkflow', this.workflows[0][0]);
        },
        runVisualization() {
            this.$root.$emit('oa-dashboard-reload');
            this.$store.dispatch("dashboard/runVisualization");
        }
    }
}
</script>

<style>
.radios {
    padding: 4px 16px;
}
</style>